import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth, API } from '../context/AuthContext';
import { colors, fonts } from '../brand';
import Disclaimer from '../components/Disclaimer';

export default function Subscribe() {
  const { token, user, refreshUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleJoin = async () => {
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/api/subscription/activate-free`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (refreshUser) await refreshUser();
      navigate('/dashboard');
    } catch (err) {
      setError('Something went wrong. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.logoArea} onClick={() => navigate('/')}>
        <img src="/logo.svg" alt="Elephants Answering" style={styles.logoIcon} />
        <div>
          <div style={styles.logoText}>Elephants Answering, PBC</div>
          <div style={styles.logoSub}>Divorce Support & Refuge</div>
        </div>
      </div>

      <div style={styles.card}>
        <h2 style={styles.title}>
          {user?.first_name ? `${user.first_name}, you're almost there.` : "You're almost there."}
        </h2>

        <div style={styles.freeBanner}>
          Membership is free while we're in beta. No credit card needed.
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <button style={styles.button} onClick={handleJoin} disabled={loading}>
          {loading ? 'Activating...' : 'Join the Community — Free'}
        </button>
      </div>
      <Disclaimer />
    </div>
  );
}

const styles = {
  page: { display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '100vh', backgroundColor: colors.cream, padding: '40px 20px' },

  logoArea: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '40px', cursor: 'pointer' },
  logoIcon: { height: '140px', width: 'auto' },
  logoText: { fontFamily: fonts.heading, color: colors.navy, fontSize: '17px', fontWeight: '600', letterSpacing: '0.5px' },
  logoSub: { fontFamily: fonts.body, color: colors.textMedium, fontSize: '11px', letterSpacing: '0.3px', marginTop: '3px' },

  card: { backgroundColor: colors.white, border: `1px solid ${colors.peach}`, padding: '48px 40px', maxWidth: '420px', width: '100%', textAlign: 'center' },

  title: { fontFamily: fonts.heading, color: colors.navy, fontSize: '26px', marginBottom: '24px', fontWeight: '600', letterSpacing: '0.3px', lineHeight: '1.4' },

  freeBanner: { backgroundColor: '#f0f7ee', border: '1px solid #a8d5a2', color: '#2d6a27', padding: '12px 16px', marginBottom: '28px', fontSize: '13px', fontFamily: fonts.body, lineHeight: '1.6' },

  error: { backgroundColor: '#fde8e8', color: '#c0392b', padding: '12px 16px', marginBottom: '20px', fontSize: '13px', fontFamily: fonts.body, border: '1px solid #f5c6c6' },

  button: { display: 'block', width: '100%', padding: '16px', backgroundColor: colors.rose, color: colors.white, border: 'none', fontSize: '14px', cursor: 'pointer', fontWeight: '600', fontFamily: fonts.body, letterSpacing: '0.5px', borderRadius: 0 },
};
